import Slide01Cover from "./Slide01Cover";
import Slide02Concetto from "./Slide02Concetto";
import Slide03Standard from "./Slide03Standard";
import Slide04Roadmap from "./Slide04Roadmap";
import Slide05Collection from "./Slide05Collection";
import Slide06Adv from "./Slide06Adv";
import Slide07Vantaggi from "./Slide07Vantaggi";
import Slide08GuestPortal from "./Slide08GuestPortal";
import Slide09CaseHistory from "./Slide09CaseHistory";
import Slide10Tesi from "./Slide10Tesi";
import Slide11Scaling from "./Slide11Scaling";
import Slide12Chiusura from "./Slide12Chiusura";

export const SLIDES = [
  { id: "cover", nav: "Cover", theme: "navy", Component: Slide01Cover },
  { id: "concetto", nav: "Il Concetto", theme: "ivory", Component: Slide02Concetto },
  { id: "standard", nav: "5-Star Standard", theme: "navy", Component: Slide03Standard },
  { id: "roadmap", nav: "Roadmap", theme: "ivory", Component: Slide04Roadmap },
  { id: "collection", nav: "La Collection", theme: "navy", Component: Slide05Collection },
  { id: "adv", nav: "Investimento ADV", theme: "ivory", Component: Slide06Adv },
  { id: "vantaggi", nav: "I Due Vantaggi", theme: "navy", Component: Slide07Vantaggi },
  { id: "guest-portal", nav: "Guest Portal", theme: "ivory", Component: Slide08GuestPortal },
  { id: "case-history", nav: "La Balena Blu", theme: "navy", Component: Slide09CaseHistory },
  { id: "la-tesi", nav: "La Tesi", theme: "ivory", Component: Slide10Tesi },
  { id: "scaling", nav: "Scaling 2028", theme: "navy", Component: Slide11Scaling },
  { id: "chiusura", nav: "La Visione", theme: "navy", Component: Slide12Chiusura },
];

export const TOTAL = SLIDES.length;
